import script from "./CssTestPage3.vue?vue&type=script&setup=true&lang=js"
export * from "./CssTestPage3.vue?vue&type=script&setup=true&lang=js"

import "./CssTestPage3.vue?vue&type=style&index=0&id=46604ab6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46604ab6"]])

export default __exports__